import React from 'react';
import { motion } from 'framer-motion';
import './Button.css';

const Button = ({ 
  primary = false, 
  secondary = false, 
  large = false, // Changed to use in className only
  children, 
  onClick, 
  type = 'button',
  ...props 
}) => {
  // Determine button style based on props
  const buttonClass = primary 
    ? 'button-primary' 
    : secondary 
      ? 'button-secondary' 
      : 'button-default';

  // Convert large boolean to class name
  const sizeClass = large ? 'button-large' : '';

  return (
    <motion.button
      className={`button ${buttonClass} ${sizeClass}`}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      type={type}
      {...props} // Spread other props (excluding large)
    >
      {children}
    </motion.button>
  );
};

export default Button;